import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
/**
 * Slider
 */
const TemplateCarouselSlider = ({slideBoxSet, contentSet, contentCount,listIdx }) => {

  const items = [];
  // set
  const [visibleSlides, setVisibleSlides] = useState(1);
  const slideBoxSize = slideBoxSet.width + slideBoxSet.margin +1;
  const messageBoxDef = useRef(0);
  useLayoutEffect(() => {
    
    let clientWidth = messageBoxDef.current.clientWidth;
    setVisibleSlides(clientWidth / slideBoxSize);

    function handleResize(a) {
      clientWidth = messageBoxDef.current.clientWidth;
      setVisibleSlides(clientWidth / slideBoxSize);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <div className="_carousel_div" key={`_carousel_div_${listIdx}`} ref={messageBoxDef}>
      <CarouselProvider key={`_carousel_provider_${listIdx}`} visibleSlides={visibleSlides} className="_message_temp_carousel_div" totalSlides={contentCount}>
        <Slider key={`_Slider_${listIdx}`}>{contentSet()}</Slider>
        <ButtonBack className="_back_button" key={`_back_button${listIdx}`}>
          <i className="ri-arrow-left-circle-line" />
        </ButtonBack>
        <ButtonNext className="_next_button" key={`_next_button${listIdx}`}>
          <i className="ri-arrow-right-circle-line" />
        </ButtonNext>
      </CarouselProvider>
    </div>
  );
};

TemplateCarouselSlider.propTypes = {
  slideBoxSet: PropTypes.object,
  listIdx: PropTypes.string,
  contentCount: PropTypes.number,
  contentSet: PropTypes.func,
};
TemplateCarouselSlider.defaultProps = {
  slideBoxSet: { width: 300, margin: 15, height: '200px' },
  contentCount: 0,
  listIdx: '',
  contentSet: () => {},
};

export default TemplateCarouselSlider;
